<template>
  <header
    class="page-finishing-header"
    :class="{
      '--sticky': stickyColumn,
    }"
  >
    <div class="page-finishing-header__column" ref="text">
      <!-- Titolo  -->
      <h1 data-animate="header-title" class="title-m">
        {{ finishing.finishingColorLabel || finishing.title }}
      </h1>
      <!-- Codice  -->
      <h2
        class="text-m text-uppercase m-top-16px"
        data-animate="header-content"
        v-if="finishing.finishingColorLabel"
      >
        {{ finishing.title }}
      </h2>
      <!-- Description  -->
      <div
        v-if="finishing.finishingColorDescription"
        data-animate="header-content"
        class="text-l m-top-6 --large"
        v-html="finishing.finishingColorDescription"
      />
    </div>

    <div class="page-finishing-header__column" ref="image">
      <div
        class="page-finishing-header__texture"
        :style="{
          '--background-color': finishing?.finishingColorCode || '#131313',
        }"
        data-animate="header-image"
      >
        <WidgetPicture
          v-if="finishing?.finishingColorTexture?.[0]"
          :image="{
            custom: {
              ...finishing.finishingColorTexture[0],
              height: 1000,
              width: 1000,
            },
          }"
          :alt="finishing.title"
        />
      </div>

      <!-- Description  -->
      <div
        class="m-top-3 --small"
        aria-hidden="true"
        v-if="finishing.finishingColorDescription"
      >
        <div
          data-animate="header-content"
          class="text-l m-top-6"
          v-html="finishing.finishingColorDescription"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesFinishingHeader',
}
</script>

<script setup>
import { debounce } from '~/assets/js/utils.js'

const props = defineProps({
  finishing: Object,
})
const text = ref(null)
const image = ref(null)

const stickyColumn = ref(false)

onMounted(() => {
  setTimeout(() => compareColumns(), 250)
  window.addEventListener('resize', debounce(compareColumns))
})

// Function to compare column dimensions
const compareColumns = () => {
  if (text.value && image.value) {
    const height1 = text?.value?.offsetHeight
    const height2 = image?.value?.offsetHeight
    if (height1 > height2) {
      stickyColumn.value = true
    } else {
      stickyColumn.value = false
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
